import { Lesson } from '../EnumTypes/ActionEnumTypes';

const init = () => ({
  type: Lesson.UPDATE_SORT_INIT,
});

export const success = (data) => ({
  type: Lesson.UPDATE_SORT_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: Lesson.UPDATE_SORT_FAILURE,
});

const updateSort = (data) => async (dispatch) => {
  dispatch(init());
  try {
    dispatch(success(data));
    return true;
  } catch (err) {
    dispatch(failure());
    return false;
  }
};

export default updateSort;
